import {
  CrudMode,
  DataDisplay,
  Grid,
  pn,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Select } from "components";
import {
  StudentTextingOptInEditResource,
  StudentTextingOptInViewResource,
  TextingOptIn,
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useNavigate } from "react-router-dom";

export const StudentTextingOptInPageBody = (props: {
  crudMode: CrudMode;
  textingOptIn: TextingOptIn;
  setTextingOptIn: (value: TextingOptIn) => void;
  viewResource: StudentTextingOptInViewResource;
  editResource: StudentTextingOptInEditResource;
  validationErrors: ValidationErrors;
}) => {
  const properties = props.viewResource.properties || [];
  const navigate = useNavigate();
  const { breakpointsRef, smallFieldBreakpoints, mediumFieldBreakpoints, largeFieldBreakpoints } =
    useElementBreakpoints();

  const textingOptInMethodField = () => {
    const propertyName = pn<TextingOptIn>("optInMethodId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.textingOptIn.optInMethod?.name}</DataDisplay>
    ) : (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.editResource.optInMethods?.find((x) => x.id === props.textingOptIn.optInMethodId)}
        options={props.editResource.optInMethods}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setTextingOptIn(
            produce(props.textingOptIn, (draft) => {
              draft.optInMethodId = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {textingOptInMethodField()}
      </Grid>
    </Grid>
  );
};
